(() => {
  if (window.replicaScentDialogReady) return;
  window.replicaScentDialogReady=true;
  document.addEventListener('click',e=>{
    const opener=e.target.closest('[data-scent-open]');
    if(opener){
      const dialog=document.getElementById(opener.getAttribute('aria-controls'));
      if(dialog){dialog._returnFocus=opener;if(dialog.showModal)dialog.showModal();else dialog.setAttribute('open','');}
    }
    const close=e.target.closest('[data-scent-close]');
    const dialog=close?.closest('dialog')||(e.target.matches('.rp-scent-dialog')?e.target:null);
    if(dialog){if(dialog.close)dialog.close();else dialog.removeAttribute('open');dialog._returnFocus?.focus();}
  });
  document.addEventListener('close',e=>{if(e.target.matches?.('.rp-scent-dialog'))e.target._returnFocus?.focus();},true);
})();
